import { LocationStoreFactory } from 'common/data/location/store.factory';
import { BuildingReviewLandingAutocompleteStore } from 'common/module/building-review-landing/autocomplete/store';
import { BuildingReviewLandingAutocompleteStatechartService } from 'common/service/building-review-landing-autocomplete-statechart/service';
import { BuildingReviewLandingFormService } from 'common/service/building-review-landing-form/service';

export function BuildingReviewLandingAutocompleteStoreFactory(): BuildingReviewLandingAutocompleteStore {
  return new BuildingReviewLandingAutocompleteStore(
    BuildingReviewLandingAutocompleteStatechartService(),
    LocationStoreFactory(),
    BuildingReviewLandingFormService()
  );
}
